import { ToolCall } from "@cohesive/api-client";
import { cx } from "class-variance-authority";
import { Check, ChevronRight } from "lucide-react";
import { titleCase } from "title-case";
import { ToolCallIcon } from "./ToolCallIcon";

function formatToolName(name: string) {
  const cleaned = name
    .split(/(?<=[a-z])(?=[A-Z])/)
    .join(" ")
    .split("_")
    .join(" ")
    .replace(/toolbox/gi, "")
    .replace(/tool/gi, "")
    .replace(/pipedream/gi, "")
    .replace(/nango/gi, "")
    .replace(/\s+/g, " ")
    .trim();
  return titleCase(cleaned);
}

const renderTitle = (call: ToolCall) => {
  if (call.function.arguments?.action_description) {
    return (
      titleCase(call.function.arguments?.action_description, {
        sentenceCase: true,
      }) + "..."
    );
  }
  if (call.function?.name) {
    return `Executing ${formatToolName(call.function.name)}...`;
  }
  return null;
};

export const ToolTitle: React.FC<{
  call: ToolCall;
  shimmer?: boolean;
}> = ({ call, shimmer }) => {
  return (
    <div className="flex items-start justify-between w-full">
      <div className="flex items-start">
        <div className="relative z-[1] grow-0 shrink-0 basis-[24px] flex items-center justify-center h-[24px] bg-background">
          <ToolCallIcon toolCall={call} />
        </div>
        <span
          className={cx("ml-2 font-sans text-sm text-n-60", {
            "shimmer text-muted-foreground":
              (!call?.user_confirmation_status && shimmer) ||
              call?.user_confirmation_status === "confirmed-processing",
          })}
        >
          {renderTitle(call)}
        </span>
      </div>
      {!shimmer && !call.user_confirmation_status && (
        <div className="flex shrink-0 items-center gap-2 self-center">
          {/* Match the completed check to the compact sandbox row (Tool_E2bBash):
              same size-3.5 green check. */}
          <Check className="size-3.5 text-lc-active" />
          {/* Invisible disclosure-chevron placeholder so the check lands in the
              same column as the expandable tool rows that DO have a chevron —
              keeping the green checkmark in a consistent spot across types. */}
          <ChevronRight className="invisible size-3.5" aria-hidden />
        </div>
      )}
    </div>
  );
};
